import { User } from '@core/models/user.model';
import { ArraySerializer, Field, Model, PrimitiveSerializer, Type } from '@junte/serialize-ts';

import { FileObject } from './file-object.model';
import { GpOwnFundDdqQuota, SubscriptionAddon } from './subscription.model';
import { ValueObject } from './value-object.model';

@Model()
export class UserProfile extends User {
  @Field()
  @Type(new PrimitiveSerializer())
  public subscription?: {
    tier?: {
      uid?: string;
      code?: string;
      name?: string;
      tierType?: 'gp' | 'lp';
      tier_type?: 'gp' | 'lp';
    };
    activeAddons?: SubscriptionAddon[];
    active_addons?: SubscriptionAddon[];
    usage?: {
      remainingDdqRuns: number | null;
      remaining_ddq_runs?: number | null;
      canGenerateIm?: boolean;
      can_generate_im?: boolean;
      ddqRunsThisMonth: number;
      ddq_runs_this_month?: number;
      imGenerationsTotal: number;
      im_generations_total?: number;
      gpOwnFundDdq?: GpOwnFundDdqQuota;
      gp_own_fund_ddq?: GpOwnFundDdqQuota;
    } | null;
  } | null;

  @Field() public address: string;
  @Field() public country: ValueObject;
  @Field() public website: string;
  @Field() public companyName: string;
  @Field() public companyRole: string;
  @Field() public language: ValueObject;
  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  public selectableLanguages?: string[];
  @Field() public provenAt: Date;
  @Field() public provenBy: string;
  @Field() public isTwoFaEnabled: boolean;
  @Field() public isSmsOtpEnabled: boolean;
  @Field() public isMarketingConsent: boolean;
  @Field() public proofDocument: FileObject | null;
  @Field() public proofNote: string;
  @Field() public hasLoggedIn: boolean;
  @Field() public emailNotificationsEnabled: boolean;

  public static create(data: Partial<UserProfile>): UserProfile {
    return Object.assign(new UserProfile(), data);
  }
}
